export const busObj = {
  id: "FB",
  headline: "Set your business apart. ",
  buttonLabel: "Join Wait list",
  imgStart: false,
  img: require("../../Assets/Images/PayAcc.png").default,
  alt: "Paythumb-accepted-card",
};
